import { useState } from 'react';
import type { MouseEvent } from 'react';
import Add from '@mui/icons-material/Add';
import type { DashboardComponent } from 'common/types/dashboard/dashboardDefinition';
import { DASHBOARD_COMPONENT_TYPES } from 'common/types/dashboard/dashboardVocabularies';
import { Button, PrimaryNavigationMenu, PrimaryNavigationMenuItem } from 'components/ui';
import { COMPONENT_TYPE_LABELS } from 'pages/Intelligence/SummaryDashboard/components/DashboardGrid/dashboardComponent.helpers';

interface AddComponentMenuProps {
  disabled?: boolean;
  label?: string;
  onAdd: (type: DashboardComponent['type']) => void;
  testId?: string;
}

// A component's `type` is required at creation and cannot be changed afterwards (it selects the
// whole fields contract), so adding is a type picker rather than an "add blank tile" button.
const AddComponentMenu = ({ disabled = false, label = 'Add component', onAdd, testId }: AddComponentMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleSelect = (type: DashboardComponent['type']) => {
    setAnchorEl(null);
    onAdd(type);
  };

  return (
    <>
      <Button
        data-testid={testId}
        disabled={disabled}
        onClick={(event: MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget)}
        sizeVariant="compact"
        startIcon={<Add fontSize="inherit" />}>
        {label}
      </Button>
      <PrimaryNavigationMenu
        anchorEl={anchorEl}
        menuWidth="content"
        onClose={() => setAnchorEl(null)}
        open={Boolean(anchorEl)}>
        {DASHBOARD_COMPONENT_TYPES.map(type => (
          <PrimaryNavigationMenuItem key={type} onClick={() => handleSelect(type)}>
            {COMPONENT_TYPE_LABELS[type]}
          </PrimaryNavigationMenuItem>
        ))}
      </PrimaryNavigationMenu>
    </>
  );
};

export default AddComponentMenu;
